import React, { useEffect, useState } from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect, useDispatch, useSelector } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from './FallbackPage';
import { ASSET_NAME } from './LandingPage.duck';
import { fromLatLng, setBounds, setDefaults } from 'react-geocode';
import { useGeolocated } from 'react-geolocated';
import { updateCurrentUserLocation } from '../../ducks/user.duck';

import { decodeLatLngBounds } from '../../util/urlHelpers';

// import { types as sdkTypes } from '../../util/sdkLoader';
// const { LatLng, LatLngBounds } = sdkTypes;

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

if (process.env.REACT_APP_ENABLE_LOCATION_TRACK === 'true') {
  setDefaults({
    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY, // Your API key here.
    language: 'en', // Default language for responses.
    region: 'us', // Default region for responses.
  });
  setBounds();
}

export const LandingPageComponent = props => {
  const { pageAssetsData, inProgress, error } = props;

  const [locationAlreadyCalled, setLocationAlreadyCalled] = useState(false);

  const dispatch = useDispatch();

  const state = useSelector(state => state);
  const user = state.user;
  const currentUserLocation = user?.currentUserLocation;
  const currentSearchPageLink = currentUserLocation?.searchPageLink;

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    process.env.REACT_APP_ENABLE_LOCATION_TRACK === 'true'
      ? useGeolocated({
          positionOptions: {
            enableHighAccuracy: false,
          },
          userDecisionTimeout: 5000,
          isOptimisticGeolocationEnabled: true,
        })
      : {};

  useEffect(() => {
    // console.log(`LandingPage coords`, coords);
    // console.log(`LandingPage isGeolocationEnabled`, isGeolocationEnabled);
    // console.log(`LandingPage locationAlreadyCalled`, locationAlreadyCalled);
    // console.log(`LandingPage currentSearchPageLink`, currentSearchPageLink);
    if (
      coords &&
      isGeolocationAvailable &&
      isGeolocationEnabled &&
      locationAlreadyCalled === false &&
      !currentSearchPageLink
    ) {
      setLocationAlreadyCalled(true);
      getSearchLinkByGeolocation();
    }
  }, [coords, isGeolocationAvailable, isGeolocationEnabled]);

  const getSearchLinkByGeolocation = async () => {
    // console.log(`LandingPage getSearchLinkByGeolocation`);
    const latitude = coords?.latitude;
    const longitude = coords?.longitude;
    // console.log(`LandingPage latitude`, latitude);
    // console.log(`LandingPage longitude`, longitude);
    return await fromLatLng(latitude, longitude)
      .then(async ({ results }) => {
        // console.log(`LandingPage fromLatLng results`, results);
        // administrative_area_level_3
        let mainIndex = 0;
        for (let i = results.length - 1; i >= 0; i--) {
          if (results[i]?.types.includes('administrative_area_level_3')) {
            mainIndex = i;
            break;
          }
        }
        // console.log(`results[${mainIndex}]`, results[mainIndex]);
        const formatted_address = results[mainIndex].formatted_address;
        const { northeast, southwest } = results[mainIndex].geometry.viewport;
        const decodedBounds = decodeLatLngBounds(
          `${northeast.lat},${northeast.lng},${southwest.lat},${southwest.lng}`
        );
        const { ne, sw } = decodedBounds;
        const ne_lat = ne.lat;
        const ne_lng = ne.lng;
        const sw_lat = sw.lat;
        const sw_lng = sw.lng;
        const link = `bounds=${ne_lat}%2C${ne_lng}%2C${sw_lat}%2C${sw_lng}`;
        // console.log(`LandingPage finalLink`, link);
        const theCurrentUserLocation = currentUserLocation ? currentUserLocation : {};
        theCurrentUserLocation.searchPageLink = link;
        theCurrentUserLocation.cityAddress = formatted_address;
        // theCurrentUserLocation.bounds = new LatLngBounds(
        //   new LatLng(ne_lat, ne_lng),
        //   new LatLng(sw_lat, sw_lng)
        // );
        await dispatch(updateCurrentUserLocation(theCurrentUserLocation));
        return theCurrentUserLocation;
      })
      .catch(error => {
        console.error(error);
        return error;
      });
  };

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
      inProgress={inProgress}
      error={error}
      fallbackPage={<FallbackPage error={error} />}
    />
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
